<template>
  <woot-modal :show.sync="show" :on-close="onCancel">
    <div class="column content-box">
      <woot-modal-header
        :header-title="$t('NEW_CONVERSATION.TITLE')"
        :header-content="$t('NEW_CONVERSATION.DESC')"
      />
      <conversation-form
        :contact="contact"
        :on-submit="onSubmit"
        @success="onSuccess"
        @cancel="onCancel"
      />
    </div>
  </woot-modal>
</template>

<script>
import ConversationForm from './ConversationForm';

export default {
  components: {
    ConversationForm,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    contact: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    'contact.id'(id) {
      this.$store.dispatch('contacts/fetchContactableInbox', id);
    },
    show(newVal) {
      if (newVal) {
        const { id } = this.contact;
        this.$store.dispatch('contacts/fetchContactableInbox', id);
      }
    },
  },
  mounted() {
    const { id } = this.contact;
    this.$store.dispatch('contacts/fetchContactableInbox', id);
  },
  methods: {
    onCancel() {
      this.$emit('cancel');
    },
    onSuccess() {
      this.$emit('cancel');
    },
    // eslint-disable-next-line consistent-return
    async onSubmit(contactItem) {
      // eslint-disable-next-line no-useless-catch
      try {
        const data = await this.$store.dispatch(
          'contactConversations/create',
          contactItem
        );
        return data;
      } catch (error) {
        if (
          error.response.data?.message.includes(
            'Conversation already present in the system'
          )
        ) {
          await this.$store.dispatch(
            'contactConversations/deleteLastContactInbox',
            contactItem.contactId
          );
        }
        throw error;
      }
    },
  },
};
</script>
